import { FindingRecord } from '@totem/components/surveyV2/building/controlSystems/types';

export const getPlainTextFinding = (record: FindingRecord) => {
  return [
    record.selectedOption?.findingDescription,
    record.question.policy,
    record.question.resolution,
  ].join('\n');
};
